import HttpService from "@krea/customer-features/services/httpService";

const instanceWithoutInterceptors =
  HttpService.createInstanceWithoutInterceptors();

interface IPendingLoanApplicationIdentifyData {
  id: string;
  type: "PENDING_LOAN_APPLICATION";
  data: {
    customerCompany: {
      organisationNumber: string | null;
      name: string | null;
    };
    requestedAmount: number;
    expiresAt: string;
    reason: string | null;
    isCustomerApplicationFlowAllowed: boolean;
    status: string | null;
    error: Record<string, unknown> | null;
    initiatingUserMobilePhoneNumber: string | null;
  };
}

interface IUnknownIdentifyData {
  id: string;
  type: "UNKNOWN";
  data: null;
}

export type IIdentifyCustomerResponse =
  | IPendingLoanApplicationIdentifyData
  | IUnknownIdentifyData;

export const identifyCustomer = async (identifyToken: string) => {
  return await instanceWithoutInterceptors.get<IIdentifyCustomerResponse>(
    "/api/v1/identify",
    {
      params: { identify: identifyToken },
    },
  );
};
